import { render, staticRenderFns } from "./SpouseParentalInfo.vue?vue&type=template&id=05f9c5cc&scoped=true&"
import script from "./SpouseParentalInfo.vue?vue&type=script&lang=js&"
export * from "./SpouseParentalInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpouseParentalInfo.vue?vue&type=style&index=0&id=05f9c5cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f9c5cc",
  null
  
)

export default component.exports